import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { WasteStationNotificationPage } from 'pages/waste-station-notification/WasteStationNotificationPage'

const wasteStationNotificationSearchSchema = z.object({
  code: z.string().catch(''),
})

export const Route = createFileRoute('/avisering-om-avfall')({
  validateSearch: wasteStationNotificationSearchSchema,
  component: WasteStationNotificationPage,
})
